import React, { Component, ReactNode } from 'react';
import CreateFolderIcon from '../../icons/CreateFolderIcon';
import GatewayContainer from '../../config/GatewayContainer';
import GatewayNames from '../../constant/GatewayNames';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ComponentCategory } from '../../domain/category/CategoryOperationDomains';
import ComponentCategoryUtil from '../../util/ComponenyCategoryUtil';
import ComponentName from '../../constant/ComponentName';
import FolderClient from 'client/folder/FolderClient';
import { ProgressSpinner } from 'primereact/progressspinner';
import RoleHelper from '../../RoleHelper';
import MessageUtil from '../../util/MessageUtil';
import LanguageUtil from '../../util/LanguageUtil';

class CreateFolderItem extends Component<Props, State> {
  private folderClient: FolderClient = GatewayContainer.getInstance().get(GatewayNames.FOLDER_CLIENT);
  public state: State = new State();

  public render(): ReactNode {
    const { loading } = this.state;
    return (
      <div className={'flex relative'}>
        <div
          className={'min-w-[120px] min-h-[100px] flex  items-center justify-center rounded-t-lg  rounded-b-lg bg-white relative folder-main opacity-40'}
        ></div>
        <div
          onClick={this.createNewFolder}
          className={`w-full h-full flex ${this.isDisabled() ? 'cursor-not-allowed' : 'cursor-pointer'} items-center absolute top-1/2 transform -translate-y-1/2   justify-center`}
        >
          {loading ? <ProgressSpinner style={{ height: '50%', width: '50%' }} /> : <CreateFolderIcon />}
        </div>
        <div
          className='h-[27px] w-[120px] opacity-100! text-[#65B0F2] bg-[#F6F6F9] text-center flex items-center justify-center absolute bottom-0 rounded-b-lg text-2xs'
          onClick={this.createNewFolder}
        >
          <a className={`${this.isDisabled() ? 'cursor-not-allowed' : 'cursor-pointer'} opacity-100!`}>
            {LanguageUtil.get({ id: 'common.label.createNewFolder', defaultMessage: 'Create new folder' })}
          </a>
        </div>
      </div>
    );
  }

  private createNewFolder = async () => {
    const { currentCategory, component } = this.props;
    if (this.isDisabled()) return;
    if (!currentCategory) return;
    this.setState({ loading: true });
    const category: ComponentCategory = ComponentCategoryUtil.getNewCategory(
      LanguageUtil.get({ id: 'common.label.untitled', defaultMessage: 'Untitled' }),
    ) as ComponentCategory;
    try {
      await this.folderClient.add(component, category, currentCategory.id).finally(() => this.setState({ loading: false }));
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'common.label.folderCreated', defaultMessage: 'Folder Created' }),
      });
    } catch (e: any) {
      console.log(e.response);
    }
  };

  private isDisabled = () => {
    const { component } = this.props;
    return !RoleHelper.canEdit(ComponentCategoryUtil.getRoleNamesByComponent(component));
  };
}

interface Props extends ReduxProps, FormicaProps {
  component: ComponentName;
}

class State {
  loading: boolean = false;
}

const mapStateToProps = (state: RootState) => ({
  currentCategory: state.page.currentCategory,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(CreateFolderItem));
